const styles = theme => ({
  dataContainer: {
    padding: '24px',
  },
  divider: {
    width: '100%',
    height: '1px !important',
    background: theme.palette.primary.borderColor,
    // margin: '20px 0',
  },
  propertyName: {
    color: theme.palette.primary.dim,
    fontSize: '16px',
  },
  propertyValue: {
    color: theme.palette.primary.ascent,
    fontSize: '18px',
    fontWeight: 600,
  },
  viewBtnContainer: {
    padding: '24px',
    textAlign: 'center',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },
  viewBtn: {
    color: theme.palette.primary.main,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    cursor: 'pointer',
  },

  '@media (max-width: 960px)': {
    viewBtnContainer: {
      padding: '16px',
    },
    viewBtn: {
      fontWeight: '500',
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
  '@media (max-width: 767px)': {
    dataContainer: {
      padding: '16px',
    },
    divider: {
      // margin: '15px 0',
    },
    propertyName: {
      fontSize: '12px',
      fontWeight: 400,
    },
    propertyValue: {
      fontSize: '12px',
      fontWeight: 500,
    },
  },
});
export default styles;
